import {
    LOCAL_VIDEO_ZOOM_CHANGED,
    REMOTE_VIDEO_ZOOM_CHANGED,
    REQUEST_VIEW_ZOOM,
    SET_LOCAL_ZOOM_SHARE_APPROVED,
    SET_MODERATOR_ZOOM_SHARE_APPROVED
} from './actionTypes';

/**
 * Stores the view zoom a remote participant applied to their own video.
 *
 * @param {string} participantId - The participant who owns the video.
 * @param {string} videoType - 'camera' or 'desktop'.
 * @param {Object} zoomState - Normalized zoom state ({ zoom, cx, cy, ar }).
 * @returns {{
 *     type: REMOTE_VIDEO_ZOOM_CHANGED,
 *     participantId: string,
 *     videoType: string,
 *     zoomState: Object
 * }}
 */
export function remoteVideoZoomChanged(participantId, videoType, zoomState) {
    return {
        type: REMOTE_VIDEO_ZOOM_CHANGED,
        participantId,
        videoType,
        zoomState
    };
}

/**
 * Records the view zoom the local participant applied to their own video on
 * the large video; the zoom-sync middleware forwards it to the others.
 *
 * @param {string} videoType - 'camera' or 'desktop'.
 * @param {Object} zoomState - Normalized zoom state ({ zoom, cx, cy, ar }).
 * @returns {{
 *     type: LOCAL_VIDEO_ZOOM_CHANGED,
 *     videoType: string,
 *     zoomState: Object
 * }}
 */
export function localVideoZoomChanged(videoType, zoomState) {
    return {
        type: LOCAL_VIDEO_ZOOM_CHANGED,
        videoType,
        zoomState
    };
}

/**
 * Asks the large video to zoom the local video on stage to a level.
 *
 * @param {number} zoom - Target view zoom.
 * @returns {{
 *     type: REQUEST_VIEW_ZOOM,
 *     zoom: number,
 *     nonce: number
 * }}
 */
export function requestViewZoom(zoom) {
    return {
        type: REQUEST_VIEW_ZOOM,
        zoom,
        nonce: Date.now()
    };
}

/**
 * Sets whether the local user approved sharing local zoom with all participants.
 *
 * @param {boolean} approved - Whether sharing is approved.
 * @returns {{
 *     type: SET_LOCAL_ZOOM_SHARE_APPROVED,
 *     approved: boolean
 * }}
 */
export function setLocalZoomShareApproved(approved) {
    return {
        type: SET_LOCAL_ZOOM_SHARE_APPROVED,
        approved
    };
}

/**
 * Sets whether a moderator approved sharing moderator pin zoom with all participants.
 *
 * @param {boolean} approved - Whether sharing is approved.
 * @returns {{
 *     type: SET_MODERATOR_ZOOM_SHARE_APPROVED,
 *     approved: boolean
 * }}
 */
export function setModeratorZoomShareApproved(approved) {
    return {
        type: SET_MODERATOR_ZOOM_SHARE_APPROVED,
        approved
    };
}
